import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 16, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-gold text-gold" : "text-stone-300"}
        />
      ))}
    </div>
  );
}
